export default __webpack_public_path__ + "static/media/fa-thin-100.5ec9f3e8.ttf";